module.exports = "/assets/7ca42b06301f6a2dcdd4f5fedecdd16a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7J.png
// module id = 1113
// module chunks = 0